module.exports = __webpack_public_path__ + "media/bootstrap-icons/front-2b68f204.svg";